<template>
  <div class="user-banner">
    <div class="container">
      <div class="user-banner__inner">
        <div class="user-banner__avatar">
          <div class="avatar" :style="avatarStyle" alt="avatar"></div>
        </div>

        <div class="user-banner__head">
          <div class="user-banner__name">
            {{ me.name }}
          </div>

          <div class="user-banner__name-bg">
            {{ me.name }}
          </div>

          <ul class="user-banner__menu--top">
            <li v-if="authUser">
              <a href="#" @click.prevent="logout">
                <i class="icon icon-home"></i>
                Logout
              </a>
            </li>

            <li v-else>
              <router-link :to="{ name: 'login' }">Login</router-link>
            </li>
          </ul>

          <UserCabinetMenu v-if="menu && menu.length" :menu="menu" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import autorization from '@/mixins/autorization';
import AutorizationService from '@/services/AutorizationService';
import UserCabinetMenu from './UserCabinetMenu.vue';

export default {
  name: 'UserBanner',
  components: { UserCabinetMenu },
  mixins: [autorization],
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    me() {
      return this.$store.getters.getMe;
    },
    authUser() {
      return this.$store.getters.getAuthUser;
    },
    avatarStyle() {
      // eslint-disable-next-line global-require
      const fallback = require('@/assets/images/avatar.svg');
      const url = this.me && this.me.avatar ? this.me.avatar : fallback;
      return {
        backgroundImage: `url(${url})`,
      };
    },
  },
  methods: {
    async logout() {
      try {
        await AutorizationService.logout();
        this.removeAutorization();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
input[type='file'] {
  display: none;
}
.user-banner {
  margin-bottom: 0 !important;
}
</style>
